// Header.jsx
import React from 'react';
import styled from '@emotion/styled';
import Logo from 'components/layout/Logo';
import Nav from 'components/layout/Nav';
import UserMenu from 'components/layout/UserMenu'; // Renamed component for clarity
import LanguageSwitcher from 'components/ui/LanguageSwitcher';
import HeaderCartButton from 'components/ui/HeaderCartButton';
import { useScrollContext } from 'context/ScrollContext';
import { useContent } from 'context/ContentContext';
import { useAuth } from 'context/AuthContext';
import { useSiteInfo } from 'hooks/useSiteInfo';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: clamp(7rem, 6vw, 8rem);
  background-color: ${({ theme, isScrolled }) =>
    isScrolled ? theme.colors.white : theme.colors.yellow};
  z-index: ${({ theme }) => theme.zIndices.navbar};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${({ theme, isScrolled }) =>
    isScrolled ? theme.shadows.md : 'none'};
  transition: ${({ theme }) => theme.transitions.default};
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${({ theme }) => theme.layouts.pagePadding};
  max-width: ${({ theme }) => theme.layouts.maxWidth};
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

const Header = () => {
  const { isScrolled } = useScrollContext();
  const { logo = {} } = useContent();
  const { user, logout } = useAuth();
  // Reachable while closed: a customer can still book tomorrow (#485).
  const { orderingEnabled } = useSiteInfo();

  // Choose logo based on scroll position (simplified logic)
  const logoSrc =
    isScrolled || window.innerWidth >= 768
      ? logo.secondaryLogo || ''
      : logo.whiteLogo || '';

  return (
    <HeaderContainer isScrolled={isScrolled}>
      <HeaderWrapper>
        <LogoContainer>
          <Logo logoSrc={logoSrc} />
        </LogoContainer>
        <RightSection>
          <Nav />
          <LanguageSwitcher />
          {orderingEnabled && <HeaderCartButton isScrolled={isScrolled} />}
          {user && <UserMenu user={user} logout={logout} />}
        </RightSection>
      </HeaderWrapper>
    </HeaderContainer>
  );
};

export default Header;
